import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import ChallengeModal from './components/ChallengeModal';
import BattlePassModal from './components/BattlePassModal';
import { getContrastColor } from '../common';
import { battlePassConfig, battlePassLevelFor } from './battlePass';
function isArenaTagPage() {
  var _app$forum$attribute, _ref, _ref2, _tagBySlug$id, _tagBySlug$id2;
  const arenaTagId = String((_app$forum$attribute = app.forum.attribute('arenaBattleTagId')) != null ? _app$forum$attribute : '');
  if (!arenaTagId || arenaTagId === '0') return false;
  const currentSlug = (_ref = (_ref2 = m.route.param('tags')) != null ? _ref2 : m.route.param('tag')) != null ? _ref : '';
  if (!currentSlug) return false;
  const allTags = app.store.all('tags');
  const tagBySlug = allTags.find(t => {
    var _ref3, _t$slug, _t$slug2, _t$attribute;
    const s = (_ref3 = (_t$slug = (_t$slug2 = t.slug) == null ? void 0 : _t$slug2.call(t)) != null ? _t$slug : (_t$attribute = t.attribute) == null ? void 0 : _t$attribute.call(t, 'slug')) != null ? _ref3 : '';
    return s.toLowerCase() === currentSlug.toLowerCase();
  });
  if (tagBySlug) return String((_tagBySlug$id = (_tagBySlug$id2 = tagBySlug.id) == null ? void 0 : _tagBySlug$id2.call(tagBySlug)) != null ? _tagBySlug$id : tagBySlug.id) === arenaTagId;
  const tagById = app.store.getById('tags', arenaTagId);
  if (tagById) {
    var _ref4, _tagById$slug, _tagById$slug2, _tagById$attribute;
    const slug = (_ref4 = (_tagById$slug = (_tagById$slug2 = tagById.slug) == null ? void 0 : _tagById$slug2.call(tagById)) != null ? _tagById$slug : (_tagById$attribute = tagById.attribute) == null ? void 0 : _tagById$attribute.call(tagById, 'slug')) != null ? _ref4 : '';
    return slug.toLowerCase() === currentSlug.toLowerCase();
  }
  return false;
}
function getArenaTag() {
  var _app$forum$attribute2, _app$store$getById;
  const arenaTagId = String((_app$forum$attribute2 = app.forum.attribute('arenaBattleTagId')) != null ? _app$forum$attribute2 : '');
  if (!arenaTagId || arenaTagId === '0') return null;
  return (_app$store$getById = app.store.getById('tags', arenaTagId)) != null ? _app$store$getById : null;
}
function arenaButtonProps() {
  var _ref5, _tag$color, _tag$color2, _tag$attribute;
  const tag = getArenaTag();
  const color = (_ref5 = (_tag$color = tag == null || (_tag$color2 = tag.color) == null ? void 0 : _tag$color2.call(tag)) != null ? _tag$color : tag == null || (_tag$attribute = tag.attribute) == null ? void 0 : _tag$attribute.call(tag, 'color')) != null ? _ref5 : null;
  if (color) {
    const textColor = getContrastColor(color);
    return {
      className: 'Button Button--primary Button--block IndexPage-newDiscussion',
      style: {
        background: color,
        'border-color': color,
        color: textColor
      }
    };
  }
  return {
    className: 'Button Button--primary Button--block IndexPage-newDiscussion'
  };
}

/**
 * "Challenge" button + "How to play" button (if a link is set in admin) +
 * "Battle Pass" button (if levels are configured in admin).
 *
 * The Battle Pass button is visible to guests too — it labels itself
 * «Боевой Пропуск» for them and «N уровень» for logged-in users. On mobile
 * the first two buttons share one row; when all three are present the
 * Battle Pass button wraps to a full-width second row (see the
 * ArenaTagButtons--threeButtons rules in forum.less). Without "How to play"
 * it simply takes that button's place next to "Challenge".
 */
function arenaButtons() {
  const props = arenaButtonProps();
  const howToPlayUrl = app.forum.attribute('arenaHowToPlayUrl') || '';
  const howToPlayNewTab = app.forum.attribute('arenaHowToPlayNewTab') !== false;
  const battlePass = battlePassConfig();
  const showBattlePass = battlePass.configured;
  const threeButtons = Boolean(howToPlayUrl) && showBattlePass;
  return m("div", {
    className: "ArenaTagButtons ".concat(threeButtons ? 'ArenaTagButtons--threeButtons' : '')
  }, m(Button, {
    className: props.className + ' ArenaTagButtons-challenge',
    style: props.style,
    icon: "fas fa-swords",
    onclick: () => app.session.user ? app.modal.show(ChallengeModal) : app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
  }, app.translator.trans('forumaker-arena.forum.challenge.btn')), howToPlayUrl && m("a", {
    className: "Button Button--block ArenaTagButtons-howToPlay",
    href: howToPlayUrl,
    target: howToPlayNewTab ? '_blank' : undefined,
    rel: howToPlayNewTab ? 'noopener noreferrer' : undefined
  }, m("i", {
    className: "Button-icon fas fa-question-circle"
  }), m("span", {
    className: "Button-label"
  }, app.translator.trans('forumaker-arena.forum.how_to_play.btn'))), showBattlePass && m(Button, {
    className: "Button Button--block ArenaTagButtons-battlePass",
    icon: "fas fa-medal",
    onclick: () => app.modal.show(BattlePassModal)
  }, app.session.user ? app.translator.trans('forumaker-arena.forum.battle_pass.btn_level', {
    level: String(battlePassLevelFor(app.session.user, battlePass))
  }) : app.translator.trans('forumaker-arena.forum.battle_pass.title')));
}
export default function addArenaTab() {
  // "Arena" tab on the profile page
  extend(UserPage.prototype, 'navItems', function (items) {
    var _app$session$user;
    const user = this.user;
    if (!user) return;
    const stats = user.attribute('arenaStats');
    if (!stats && ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) !== user.id()) return;
    items.add('arena', m(LinkButton, {
      href: app.route('user.arena', {
        username: user.username()
      }),
      icon: "fas fa-dungeon"
    }, app.translator.trans('forumaker-arena.forum.user.arena_tab')), 70);
  });

  // Buttons on the Arena tag page.
  // Flarum 2.x: the sidebar is a separate IndexSidebar component with an
  // items() method (IndexPage.sidebarItems / heroItems were the 1.x API and
  // don't exist in 2.x). Desktop: buttons at the top of the sidebar instead
  // of "Create discussion". Mobile: the same item renders inline between the
  // hero and the discussion list.
  extend(IndexSidebar.prototype, 'items', function (items) {
    if (!isArenaTagPage()) return;
    if (items.has('newDiscussion')) items.remove('newDiscussion');
    items.add('challengeBattle', arenaButtons(), 100);
  });
}